export default {
  ui: {
    request: {
      baseUrl: '',
      timeout: 60 * 1000,
    },
    noAuthLogOff: true,
    '3rdParties': {
      i18nextDebug: true,
    },
    timeZone: {
      defaultOffsetId: '32',
      defaultOffset: '+00:00',
    },
    feature: {
      phishInsight:
        'https://stg.phishinsight.trendmicro.com/api/auth/sso/clp/?sso',
    },
  },
};
